<template>
  <a-modal title="沟通记录" v-model="visible">
    <div v-for="(item, index) in list" :key="item.id">
      <a-row type="flex" justify="space-between">
        <a-col>
          <h3>{{item.type_name}}</h3>
        </a-col>
        <a-col>{{item.created_at}}</a-col>
      </a-row>
      <p style="color:#999">反馈人：{{item.user_name}}</p>
      <div>{{item.body}}</div>
      <a-divider v-if="(index+1) < list.length"></a-divider>
    </div>
    <template slot="footer">
      <a-button @click="close">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
import baseModalVue from "@/components/base-modal";
import Api from "@/api";
export default {
  name: "MarkDetailModal",
  extends: baseModalVue,
  data() {
    return {
      list: []
    };
  },
  methods: {
    async show(record) {
      if (record.status === "CREATE") {
        this.$message.error("暂无沟通记录");
        return;
      }
      let { job_clues: list } = await Api.cash.JobCommunicationList({
        job_clue_id: record.id
      });
      list = list.filter(item => item.type !== "CREATE");
      this.list = list;
      this.open();
    }
  }
};
</script>

<style lang="scss">
</style>
